(function() {
  function $parcel$export(e, n, v, s) {
    Object.defineProperty(e, n, {
      get: v,
      set: s,
      enumerable: true,
      configurable: true
    });
  }
  var $parcel$global = typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : typeof global !== "undefined" ? global : {};
  var $parcel$modules = {};
  var $parcel$inits = {};
  var parcelRequire = $parcel$global["parcelRequire5f74"];
  if (parcelRequire == null) {
    parcelRequire = function(id) {
      if (id in $parcel$modules) {
        return $parcel$modules[id].exports;
      }
      if (id in $parcel$inits) {
        var init = $parcel$inits[id];
        delete $parcel$inits[id];
        var module = {
          id: id,
          exports: {}
        };
        $parcel$modules[id] = module;
        init.call(module.exports, module, module.exports);
        return module.exports;
      }
      var err = new Error("Cannot find module '" + id + "'");
      err.code = "MODULE_NOT_FOUND";
      throw err;
    };
    parcelRequire.register = function register(id, init) {
      $parcel$inits[id] = init;
    };
    $parcel$global["parcelRequire5f74"] = parcelRequire;
  }
  var parcelRegister = parcelRequire.register;
  parcelRegister("6ph3s", function(module, exports) {
    $parcel$export(module.exports, "default", function() {
      return $4aa24e9d49d5ff32$export$2e2bcd8739ae039;
    });
    var $7bS3h = parcelRequire("7bS3h");
    const $4aa24e9d49d5ff32$var$formatPrice = (amount, currencyCode) => {
      const needsCode = [ "USD", "CAD", "AUD", "HKD", "SGD", "NZD", "SEK", "DKK", "NOK", "CHF" ].includes(currencyCode);
      const needsSymbol = [ "USD", "CAD", "AUD", "HKD", "SGD", "NZD" ].includes(currencyCode);
      if (needsCode) {
        const symbol = needsSymbol ? "$" : "";
        const formattedAmount = (0, $7bS3h.default)(amount, "{{amount_no_decimals}}");
        return `${symbol}${formattedAmount} <span class="text-3xs">${currencyCode}</span>`;
      }
      return (0, $7bS3h.default)(amount, Shopify.money_format).replace(/\.00$/, "");
    };
    var $4aa24e9d49d5ff32$export$2e2bcd8739ae039 = $4aa24e9d49d5ff32$var$formatPrice;
  });
  parcelRegister("7bS3h", function(module, exports) {
    $parcel$export(module.exports, "default", function() {
      return $53c37d114b9030f9$export$2e2bcd8739ae039;
    });
    function $53c37d114b9030f9$export$2e2bcd8739ae039(cents, format) {
      let value = "";
      const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
      const formatString = format || window.Shopify?.money_format || "${{amount}}";
      const defaultOption = (opt, def) => typeof opt === "undefined" ? def : opt;
      const formatWithDelimiters = (number, precision, thousands, decimal) => {
        const resolvedPrecision = defaultOption(precision, 2);
        const resolvedThousands = defaultOption(thousands, ",");
        const resolvedDecimal = defaultOption(decimal, ".");
        if (isNaN(number) || number == null) return 0;
        const fixed = (number / 100).toFixed(resolvedPrecision);
        const parts = fixed.split(".");
        const dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + resolvedThousands);
        const centsPart = parts[1] ? resolvedDecimal + parts[1] : "";
        return dollars + centsPart;
      };
      let normalized = cents;
      if (typeof normalized === "string") normalized = normalized.replace(".", "");
      const match = formatString.match(placeholderRegex);
      const token = match ? match[1] : "amount";
      switch (token) {
       case "amount":
        value = formatWithDelimiters(normalized, 2);
        break;

       case "amount_no_decimals":
        value = formatWithDelimiters(normalized, 0);
        break;

       case "amount_with_comma_separator":
        value = formatWithDelimiters(normalized, 2, ".", ",");
        break;

       case "amount_no_decimals_with_comma_separator":
        value = formatWithDelimiters(normalized, 0, ".", ",");
        break;

       default:
        value = formatWithDelimiters(normalized, 2);
        break;
      }
      return formatString.replace(placeholderRegex, value).replace(/(\.|,)00$/g, "");
    }
  });
  parcelRegister("cJzMp", function(module, exports) {
    $parcel$export(module.exports, "createLogger", function() {
      return $94557121a748c06f$export$fe2e61603b61130d;
    });
    $parcel$export(module.exports, "serializeError", function() {
      return $94557121a748c06f$export$46ff38bc6bdea8fb;
    });
    $parcel$export(module.exports, "withDebugReason", function() {
      return $94557121a748c06f$export$4ecc6b6d3cd743de;
    });
    const $94557121a748c06f$var$LS_KEY = "mbf_debug";
    const $94557121a748c06f$var$CATEGORIES = [ "lifecycle", "events", "network", "ui", "animation", "errors" ];
    const $94557121a748c06f$var$CATEGORY_STYLES = {
      lifecycle: "color:#6366f1;font-weight:bold",
      events: "color:#10b981;font-weight:bold",
      network: "color:#3b82f6;font-weight:bold",
      ui: "color:#f59e0b;font-weight:bold",
      animation: "color:#ec4899;font-weight:bold",
      errors: "color:#ef4444;font-weight:bold"
    };
    const $94557121a748c06f$var$FILE_STYLE = "color:#94a3b8;font-style:italic";
    const $94557121a748c06f$var$LABEL_STYLE = "color:#475569";
    const $94557121a748c06f$var$BATCH_WINDOW_MS = 120;
    const $94557121a748c06f$var$GROUPED_LOG_RULES = [ {
      file: "tagalys-helpers",
      category: "ui"
    } ];
    const $94557121a748c06f$var$groupedLogBuffers = new Map;
    const $94557121a748c06f$var$groupedLogTimers = new Map;
    function $94557121a748c06f$var$defaultConfig() {
      const categories = {};
      $94557121a748c06f$var$CATEGORIES.forEach(c => categories[c] = true);
      return {
        enabled: false,
        categories: categories,
        files: {}
      };
    }
    function $94557121a748c06f$var$load() {
      try {
        const raw = localStorage.getItem($94557121a748c06f$var$LS_KEY);
        if (!raw) return $94557121a748c06f$var$defaultConfig();
        const parsed = JSON.parse(raw);
        const cfg = $94557121a748c06f$var$defaultConfig();
        cfg.enabled = !!parsed.enabled;
        if (parsed.categories && typeof parsed.categories === "object") Object.keys(cfg.categories).forEach(k => {
          if (k in parsed.categories) cfg.categories[k] = !!parsed.categories[k];
        });
        if (parsed.files && typeof parsed.files === "object") cfg.files = parsed.files;
        return cfg;
      } catch {
        return $94557121a748c06f$var$defaultConfig();
      }
    }
    function $94557121a748c06f$var$save(cfg) {
      try {
        localStorage.setItem($94557121a748c06f$var$LS_KEY, JSON.stringify(cfg));
      } catch {}
    }
    let $94557121a748c06f$var$_config = typeof window !== "undefined" ? $94557121a748c06f$var$load() : {
      enabled: false
    };
    function $94557121a748c06f$var$_emit(filename, category, args) {
      if (!$94557121a748c06f$var$_config.enabled) return;
      if (!$94557121a748c06f$var$_config.categories[category]) return;
      if ($94557121a748c06f$var$_config.files[filename] === false) return;
      if ($94557121a748c06f$var$shouldGroupLog(filename, category)) {
        $94557121a748c06f$var$queueGroupedLog(filename, category, args);
        return;
      }
      const catStyle = $94557121a748c06f$var$CATEGORY_STYLES[category] ?? "color:#64748b;font-weight:bold";
      const prefix = `%c[DEBUG] %c[${category}] %c[${filename}]`;
      if (category === "errors") console.error(prefix, $94557121a748c06f$var$LABEL_STYLE, catStyle, $94557121a748c06f$var$FILE_STYLE, ...args); else console.log(prefix, $94557121a748c06f$var$LABEL_STYLE, catStyle, $94557121a748c06f$var$FILE_STYLE, ...args);
    }
    function $94557121a748c06f$var$shouldGroupLog(filename, category) {
      return $94557121a748c06f$var$GROUPED_LOG_RULES.some(rule => rule.file === filename && rule.category === category);
    }
    function $94557121a748c06f$var$groupedKey(filename, category) {
      return `${filename}::${category}`;
    }
    function $94557121a748c06f$var$queueGroupedLog(filename, category, args) {
      const key = $94557121a748c06f$var$groupedKey(filename, category);
      const buffer = $94557121a748c06f$var$groupedLogBuffers.get(key) || [];
      buffer.push(args);
      $94557121a748c06f$var$groupedLogBuffers.set(key, buffer);
      if ($94557121a748c06f$var$groupedLogTimers.has(key)) return;
      const timer = setTimeout(() => {
        $94557121a748c06f$var$groupedLogTimers.delete(key);
        $94557121a748c06f$var$flushGroupedLogs(filename, category);
      }, $94557121a748c06f$var$BATCH_WINDOW_MS);
      $94557121a748c06f$var$groupedLogTimers.set(key, timer);
    }
    function $94557121a748c06f$var$flushGroupedLogs(filename, category) {
      const key = $94557121a748c06f$var$groupedKey(filename, category);
      const buffer = $94557121a748c06f$var$groupedLogBuffers.get(key);
      if (!buffer || buffer.length === 0) return;
      $94557121a748c06f$var$groupedLogBuffers.delete(key);
      const catStyle = $94557121a748c06f$var$CATEGORY_STYLES[category] ?? "color:#64748b;font-weight:bold";
      const header = `%c[DEBUG] %c[${category}] %c[${filename}] %c(${buffer.length} logs batched)`;
      console.groupCollapsed(header, $94557121a748c06f$var$LABEL_STYLE, catStyle, $94557121a748c06f$var$FILE_STYLE, "color:#64748b");
      buffer.forEach(entryArgs => {
        console.log(...entryArgs);
      });
      console.groupEnd();
    }
    function $94557121a748c06f$var$createRealLogger(filename) {
      return function log(category, ...args) {
        $94557121a748c06f$var$_emit(filename, category, args);
      };
    }
    const $94557121a748c06f$export$fe2e61603b61130d = () => () => {};
    function $94557121a748c06f$export$46ff38bc6bdea8fb(error) {
      if (error instanceof Error) return {
        name: error.name,
        message: error.message,
        stack: error.stack
      };
      return {
        value: error
      };
    }
    function $94557121a748c06f$export$4ecc6b6d3cd743de(reason, details = {}) {
      return {
        reason: reason,
        ...details
      };
    }
    const $94557121a748c06f$export$282d649a8a633ddc = {
      start() {
        $94557121a748c06f$var$_config.enabled = true;
        $94557121a748c06f$var$save($94557121a748c06f$var$_config);
        console.log("%c[DEBUG] Logging enabled. Reload the page for full coverage.", "color:#10b981;font-weight:bold");
        this.status();
      },
      stop() {
        $94557121a748c06f$var$_config.enabled = false;
        $94557121a748c06f$var$save($94557121a748c06f$var$_config);
        console.log("%c[DEBUG] Logging disabled.", "color:#ef4444;font-weight:bold");
      },
      enable(category) {
        if (!$94557121a748c06f$var$CATEGORIES.includes(category)) {
          console.warn(`[DEBUG] Unknown category "${category}". Available: ${$94557121a748c06f$var$CATEGORIES.join(", ")}`);
          return;
        }
        $94557121a748c06f$var$_config.categories[category] = true;
        $94557121a748c06f$var$save($94557121a748c06f$var$_config);
        console.log(`%c[DEBUG] Category "${category}" enabled.`, "color:#10b981");
      },
      disable(category) {
        if (!$94557121a748c06f$var$CATEGORIES.includes(category)) {
          console.warn(`[DEBUG] Unknown category "${category}". Available: ${$94557121a748c06f$var$CATEGORIES.join(", ")}`);
          return;
        }
        $94557121a748c06f$var$_config.categories[category] = false;
        $94557121a748c06f$var$save($94557121a748c06f$var$_config);
        console.log(`%c[DEBUG] Category "${category}" disabled.`, "color:#f59e0b");
      },
      enableFile(file) {
        delete $94557121a748c06f$var$_config.files[file];
        $94557121a748c06f$var$save($94557121a748c06f$var$_config);
        console.log(`%c[DEBUG] File "${file}" re-enabled.`, "color:#10b981");
      },
      disableFile(file) {
        $94557121a748c06f$var$_config.files[file] = false;
        $94557121a748c06f$var$save($94557121a748c06f$var$_config);
        console.log(`%c[DEBUG] File "${file}" disabled.`, "color:#f59e0b");
      },
      status() {
        const categoryRows = $94557121a748c06f$var$CATEGORIES.map(c => ({
          category: c,
          enabled: $94557121a748c06f$var$_config.categories[c] ? "✅" : "❌"
        }));
        const fileRows = Object.entries($94557121a748c06f$var$_config.files).map(([f, v]) => ({
          file: f,
          enabled: v ? "✅" : "❌"
        }));
        console.group("%c[DEBUG] Status", "color:#6366f1;font-weight:bold");
        console.log("Logging:", $94557121a748c06f$var$_config.enabled ? "%c enabled" : "%c disabled", $94557121a748c06f$var$_config.enabled ? "color:#10b981;font-weight:bold" : "color:#ef4444;font-weight:bold");
        console.log("localStorage key:", $94557121a748c06f$var$LS_KEY);
        console.table(categoryRows);
        if (fileRows.length) {
          console.log("File overrides:");
          console.table(fileRows);
        } else console.log("File overrides: none (all files active)");
        console.groupEnd();
      },
      reset() {
        localStorage.removeItem($94557121a748c06f$var$LS_KEY);
        $94557121a748c06f$var$_config = $94557121a748c06f$var$defaultConfig();
        console.log("%c[DEBUG] Settings cleared from localStorage.", "color:#f59e0b;font-weight:bold");
      },
      help() {
        console.group("%c[DEBUG] Available commands", "color:#6366f1;font-weight:bold");
        console.log([ "__debug.start()               — enable all logging", "__debug.stop()                — disable all logging", "__debug.status()              — show current config", '__debug.enable("category")    — enable a category', '__debug.disable("category")   — disable a category', `__debug.enable("…")           — categories: ${$94557121a748c06f$var$CATEGORIES.join(", ")}`, '__debug.enableFile("file")    — un-exclude a file', '__debug.disableFile("file")   — exclude a file from output', "__debug.reset()               — clear all settings from localStorage", "__debug.help()                — show this help" ].join("\n"));
        console.groupEnd();
      }
    };
  });
  var $6ph3s = parcelRequire("6ph3s");
  var $cJzMp = parcelRequire("cJzMp");
  (() => {
    if (customElements.get("product-form-sticky")) return;
    customElements.define("product-form-sticky", class ProductFormSticky extends HTMLElement {
      constructor() {
        super();
        this.log = (0, $cJzMp.createLogger)("product-form-sticky");
        this.formID = this.getAttribute("data-form");
        const observerOffset = Number.parseInt(this.getAttribute("data-observer-offset") || "0", 10);
        this.observerOffset = Number.isFinite(observerOffset) ? observerOffset : 0;
        this.productFormEl = document.querySelector(`product-form[form="${this.formID}"]`);
        this.stickyBarEl = this.querySelector("[data-sticky]");
        this.atcButtonEl = this.querySelector("[data-sticky-primary]");
        this.showOptionsButtonEl = this.querySelector("[data-sticky-show-options]");
        this.priceEls = this.querySelectorAll("[data-price]");
        this.compareAtPriceEls = this.querySelectorAll("[data-compare-at-price]");
        this.titleEl = this.querySelector("[data-sticky-variant-title]");
        this.metaEl = this.querySelector("[data-sticky-variant-meta]");
        this.unitLabelEl = this.querySelector("[data-variant-unit-label]");
        this.eventTermsEl = this.querySelector("[data-event-terms]");
        this.eventTermsCheckbox = this.querySelector("[data-event-terms-checkbox]");
        this.eventTermsCheckboxUI = this.querySelector("[data-event-terms-checkbox-ui]");
        this.eventTermsWarning = this.querySelector("[data-event-terms-warning]");
        this.eventTermsProperty = this.querySelector("[data-event-terms-property]");
        this.handleChange = this._handleChange.bind(this);
        this.handleIntersection = this._handleIntersection.bind(this);
        this.handleFooterIntersection = this._handleFooterIntersection.bind(this);
        this.handleShowOptionsClick = this._handleShowOptionsClick.bind(this);
        this.handlePrimaryClick = this._handlePrimaryClick.bind(this);
        this.handleEventTermsChange = this._handleEventTermsChange.bind(this);
        this.isProductFormIntersecting = true;
        this.isFooterIntersecting = false;
      }
      connectedCallback() {
        if (!this.productFormEl || !this.stickyBarEl || !this.atcButtonEl || !this.showOptionsButtonEl) {
          console.warn("[ProductFormSticky] Missing required elements, component disabled.", {
            formID: this.formID
          });
          return;
        }
        this.productFormEl.addEventListener("variant:change", this.handleChange);
        this.showOptionsButtonEl.addEventListener("click", this.handleShowOptionsClick);
        this.atcButtonEl.addEventListener("click", this.handlePrimaryClick);
        this.eventTermsCheckbox?.addEventListener("change", this.handleEventTermsChange);
        this._syncEventTermsProperty();
        this._updateVariantState(this.productFormEl.currentVariant, this.productFormEl.getCurrentVariantSummary?.());
        const targetContainer = this.productFormEl;
        if (targetContainer) {
          this.observer = new IntersectionObserver(this.handleIntersection, {
            rootMargin: "-100px 0px 0px 0px"
          });
          this.observer.observe(targetContainer);
        }
        this.footerEl = document.querySelector("footer.section--footer, footer");
        if (this.footerEl) {
          this.footerObserver = new IntersectionObserver(this.handleFooterIntersection, {
            threshold: 0
          });
          this.footerObserver.observe(this.footerEl);
        }
      }
      disconnectedCallback() {
        this.observer?.disconnect();
        this.footerObserver?.disconnect();
        this.productFormEl?.removeEventListener("variant:change", this.handleChange);
        this.showOptionsButtonEl?.removeEventListener("click", this.handleShowOptionsClick);
        this.atcButtonEl?.removeEventListener("click", this.handlePrimaryClick);
        this.eventTermsCheckbox?.removeEventListener("change", this.handleEventTermsChange);
        document.dispatchEvent(new CustomEvent("global-ui:bottom-right-nudge", {
          detail: {
            source: "product-form-sticky",
            transform: ""
          }
        }));
      }
      _handleChange(event) {
        this._updateVariantState(event.detail?.variant, event.detail?.variantSummary);
      }
      _updateVariantState(variant, variantSummary = null) {
        this.currentVariant = variant;
        this.currentVariantSummary = variantSummary || this._getVariantSummary(variant);
        this._updateSummary();
        this._updatePrice();
        this._updateButton();
        this._updateEventTermsState();
      }
      _getVariantSummary(variant) {
        if (!variant) return null;
        const variantMap = this.productFormEl?.getVariantMapData?.() || {};
        return variantMap?.[variant.id] || variantMap?.[String(variant.id)] || null;
      }
      _updateSummary() {
        const summary = this.currentVariantSummary;
        if (this.titleEl) this.titleEl.textContent = summary?.title || this.currentVariant?.title || "";
        if (this.metaEl) {
          const metaHtml = (summary?.meta_html || "").trim();
          if (metaHtml) this.metaEl.innerHTML = `<span class="inline-flex flex-wrap items-center gap-x-1.5 gap-y-0">${metaHtml}</span>`; else this.metaEl.textContent = summary?.meta || "";
        }
        if (this.unitLabelEl) {
          const unitLabel = (summary?.unit_label || "").trim();
          this.unitLabelEl.textContent = unitLabel;
          this.unitLabelEl.classList.toggle("hidden", !unitLabel);
        }
      }
      _updateButton() {
        const variant = this.currentVariant;
        const summaryButton = this.currentVariantSummary?.button || null;
        const isAvailable = variant?.available;
        const isSoldOut = variant && !isAvailable;
        let buttonText;
        if (summaryButton?.text) buttonText = summaryButton.text; else if (isAvailable) buttonText = window.MBF.strings.addToCart; else if (isSoldOut) buttonText = window.MBF.strings.soldOut; else buttonText = window.MBF.strings.selectOptions;
        const isDisabled = typeof summaryButton?.disabled === "boolean" ? summaryButton.disabled : !isAvailable;
        const innerTextEl = this.atcButtonEl.querySelector("[data-atc-text]");
        if (innerTextEl) innerTextEl.textContent = buttonText; else this.atcButtonEl.textContent = buttonText;
        this.atcButtonEl.disabled = isDisabled;
        this.atcButtonEl.classList.toggle("btn--primary", !isDisabled);
        this.atcButtonEl.classList.toggle("btn--secondary", isDisabled);
        const innerPriceEl = this.atcButtonEl.querySelector("[data-atc-price]");
        innerPriceEl?.classList.toggle("hidden", isDisabled);
        innerPriceEl?.classList.toggle("flex", !isDisabled);
      }
      _updatePrice() {
        const variant = this.currentVariant;
        const price = variant?.price ?? 0;
        const compareAtPrice = variant?.compare_at_price ?? 0;
        const onSale = compareAtPrice > price;
        this.priceEls.forEach(el => {
          el.innerHTML = (0, $6ph3s.default)(price, window.Shopify.currency.active);
        });
        this.compareAtPriceEls.forEach(el => {
          el.innerHTML = onSale ? (0, $6ph3s.default)(compareAtPrice, window.Shopify.currency.active) : "";
        });
      }
      _handleShowOptionsClick(event) {
        event.preventDefault();
        this._scrollToProductForm();
      }
      _handlePrimaryClick(event) {
        event.preventDefault();
        if (this.atcButtonEl.disabled) return;
        if (this._hasEventTermsRequirement() && !this.eventTermsCheckbox?.checked) {
          this._setEventTermsInvalidState(true);
          this._syncEventTermsProperty();
          this.eventTermsCheckbox.focus();
          return;
        }
        this._setEventTermsInvalidState(false);
        this._syncEventTermsProperty();
        this._syncMainFormEventTerms();
        const mainAtcButton = this.productFormEl?.querySelector('[data-atc] button[type="submit"]');
        if (!mainAtcButton) {
          console.warn("[ProductFormSticky] Main ATC button not found.", {
            formID: this.formID
          });
          return;
        }
        mainAtcButton.click();
      }
      _handleEventTermsChange() {
        this._syncEventTermsProperty();
        if (this.eventTermsCheckbox?.checked) this._setEventTermsInvalidState(false);
      }
      _scrollToProductForm() {
        if (!this.productFormEl) {
          this.log("ui", "[_scrollToProductForm] Aborted — no productFormEl");
          return;
        }
        const headerHeight = document.querySelector("header")?.clientHeight || 0;
        const padding = 20;
        const stickyTopOffset = headerHeight + padding;
        const formRect = this.productFormEl.getBoundingClientRect();
        const isDesktop = window.matchMedia("(min-width: 1024px)").matches;
        if (isDesktop) {
          if (formRect.top <= headerHeight) {
            window.scrollTo({
              top: formRect.top + window.scrollY - stickyTopOffset,
              behavior: "smooth"
            });
            return;
          }
          const sidebar = this.productFormEl.closest("[data-sticky-sidebar]");
          const sidebarParent = sidebar?.parentElement;
          if (sidebar && sidebarParent) {
            const parentRect = sidebarParent.getBoundingClientRect();
            const sidebarRect = sidebar.getBoundingClientRect();
            const parentTopMinusHeader = parentRect.top - headerHeight;
            const sidebarTopMinusHeader = sidebarRect.top - headerHeight;
            const parentOffsetTop = parentTopMinusHeader + window.scrollY;
            const heightDifference = parentRect.height - sidebarRect.height;
            const sidebarFinalAbsoluteTop = parentOffsetTop + heightDifference;
            const formOffsetInsideSidebar = formRect.top - sidebarTopMinusHeader;
            const formFinalAbsoluteTop = sidebarFinalAbsoluteTop + formOffsetInsideSidebar;
            const scrollTarget = formFinalAbsoluteTop - stickyTopOffset;
            window.scrollTo({
              top: Math.max(scrollTarget, 0),
              behavior: "smooth"
            });
            return;
          }
        }
        const mobileTarget = Math.max(formRect.top + window.scrollY - stickyTopOffset, 0);
        window.scrollTo({
          top: mobileTarget,
          behavior: "smooth"
        });
      }
      _hasEventTermsRequirement() {
        return Boolean(this.eventTermsEl && this.eventTermsCheckbox);
      }
      _syncEventTermsProperty() {
        if (!this.eventTermsProperty || !this.eventTermsCheckbox) return;
        this.eventTermsProperty.value = this.eventTermsCheckbox.checked ? "true" : "false";
      }
      _setEventTermsInvalidState(isInvalid) {
        if (!this._hasEventTermsRequirement()) return;
        this.eventTermsEl.classList.toggle("is-invalid", isInvalid);
        this.eventTermsCheckbox.setAttribute("aria-invalid", String(isInvalid));
        this.eventTermsWarning?.classList.toggle("hidden", !isInvalid);
        if (this.eventTermsCheckboxUI) {
          this.eventTermsCheckboxUI.classList.toggle("border-red", isInvalid);
          this.eventTermsCheckboxUI.classList.toggle("border-scheme-border", !isInvalid);
        }
      }
      _syncMainFormEventTerms() {
        if (!this._hasEventTermsRequirement()) return;
        const mainTermsCheckbox = this.productFormEl?.querySelector("[data-event-terms-checkbox]");
        if (!mainTermsCheckbox) return;
        if (mainTermsCheckbox.checked !== this.eventTermsCheckbox.checked) mainTermsCheckbox.checked = this.eventTermsCheckbox.checked;
        mainTermsCheckbox.dispatchEvent(new Event("change", {
          bubbles: true
        }));
      }
      _updateEventTermsState() {
        if (!this._hasEventTermsRequirement()) return;
        const isSoldOut = this.currentVariant && !this.currentVariant.available;
        this.eventTermsEl.classList.toggle("hidden", Boolean(isSoldOut));
        if (isSoldOut) {
          this.eventTermsCheckbox.checked = false;
          this._syncEventTermsProperty();
          this._setEventTermsInvalidState(false);
        }
      }
      _handleIntersection(entries) {
        const entry = entries[0];
        this.isProductFormIntersecting = entry.isIntersecting;
        this._updateStickyVisibility();
      }
      _handleFooterIntersection(entries) {
        const entry = entries[0];
        this.isFooterIntersecting = entry.isIntersecting;
        this._updateStickyVisibility();
      }
      _updateStickyVisibility() {
        const shouldBeVisible = !this.isProductFormIntersecting && !this.isFooterIntersecting;
        this.stickyBarEl.classList.toggle("translate-y-full", !shouldBeVisible);
        this.stickyBarEl.classList.toggle("opacity-0", !shouldBeVisible);
        this.stickyBarEl.classList.toggle("pointer-events-none", !shouldBeVisible);
        this._adjustLoadingSpinnerPosition(shouldBeVisible);
      }
      _adjustLoadingSpinnerPosition(stickyBarVisible) {
        if (stickyBarVisible) {
          const stickyBarHeight = this.stickyBarEl.offsetHeight;
          const stickyBarStyles = window.getComputedStyle(this.stickyBarEl);
          const marginTop = parseInt(stickyBarStyles.marginTop, 10) || 0;
          const marginBottom = parseInt(stickyBarStyles.marginBottom, 10) || 0;
          const totalHeight = stickyBarHeight + marginTop + marginBottom;
          document.dispatchEvent(new CustomEvent("global-ui:bottom-right-nudge", {
            detail: {
              source: "product-form-sticky",
              transform: `translateY(-${totalHeight}px)`
            }
          }));
        } else document.dispatchEvent(new CustomEvent("global-ui:bottom-right-nudge", {
          detail: {
            source: "product-form-sticky",
            transform: ""
          }
        }));
      }
    });
  })();
})();